import React, {useEffect, useState} from "react";
import rowNextIcon from "../../img/nextRowIcon.svg";
import imageDoc from "../../img/manDocumentPage.jpg";
import SendForSignature from "../SendForSignature/SendForSignature";
import {findStatusDocument} from "../../utils/FindStatusDocument/FindStatusDocument";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import {axiosGetHistoryStatusMan} from "../../Api/ApiHistoryStatus/axiosGetHistoryStatusMan";
import {axiosGetListManCorrector} from "../../Api/ApiManCorrector/axiosGetListManCorrector";
import CreateDocSetManCorrectorModal from "../CreateDocSetManCorrectorModal/CreateDocSetManCorrectorModal";
import UploadTemplateDocument from "../UploadTemplateDocument/UploadTemplateDocument";
import useOnSetSelectedTemplate from "../../utils/CustomHooks/useOnSetSelectedTemplate/useOnSetSelectedTemplate";
import useGetListTemplate from "../../utils/CustomHooks/useGetListTemplate/useGetListTemplate";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";

const SelectedDocSetMan = (props) => {

    const {
        selectedCargoCaseMan,
        isBolsNumbers,
        onEditHandler,
        cargoCaseDocId
    } = props;

    const { auth } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const [isTextMessage, setTextMessage] = useState('');
    const [currentStatusMan, setCurrentStatusMan] = useState([]);
    const [getListManCorrector, setListManCorrector] = useState([]);
    const [getCurrentListManCorrector, setCurrentListManCorrector] = useState([]);
    const [activeModalManCorrector, setActiveModalManCorrector] = useState(false);
    const [isSelectedManCorrector, setSelectedManCorrector] = useState({});
    const { isLinkTemplate} = useOnSetSelectedTemplate(auth, selectedCargoCaseMan[0]?.id, selectedCargoCaseMan[0]?.template?.id, true, undefined, selectedCargoCaseMan);
    // const {isOptionsTemplate} = useGetListTemplate(auth?.user?.organization, 'MAN');

    useEffect(() => {
        if (selectedCargoCaseMan.length !== 0) {

            let isLoading = true;

            axiosGetHistoryStatusMan(axiosPrivate, selectedCargoCaseMan[0]?.id, isLoading, setCurrentStatusMan);
            axiosGetListManCorrector(axiosPrivate, isLoading, setListManCorrector)

            return () => {
                isLoading = false;
            }
        }
    }, [selectedCargoCaseMan, axiosPrivate])

    useEffect(() => {

        let isLoading = true;

        const selectMan = []
            getListManCorrector.forEach(elem => {
                if (elem?.manifest?.id === selectedCargoCaseMan[0]?.id) {
                    selectMan.push(elem)
                    isLoading && setCurrentListManCorrector(selectMan)
                }
            });

        return () => {
            isLoading = false;
        }

    },[getListManCorrector])

    const onShowSelectManCorrector = (id) => {
        if (id !== undefined) {
            const findManCorrector = getCurrentListManCorrector.find(el => el?.id === id);
            setSelectedManCorrector(findManCorrector);
            setActiveModalManCorrector(true);
        }
    }

    return (
        <div className="selected-doc-set-man__container">
            <div className="selected-doc-set-man-row-current-bol">
                <p className="selected-doc-set-man-row-current-bol__label-bol">MAN</p>
                <img className="selected-doc-set-man-row-current-bol__icon" src={rowNextIcon} alt={'иконка стрелочка'}/>
                <p className="selected-doc-set-man-row-current-bol__current-bol">{selectedCargoCaseMan[0]?.number}</p>
            </div>
            <div className="selected-doc-set-man-title">
                <div className="selected-doc-set-man-title__bol-doc-icon">
                    <p className="selected-doc-set-man-title__bol-doc-name">{selectedCargoCaseMan[0]?.number}</p>
                    <img className="selected-doc-set-man-title__icon-status" src={findStatusDocument(selectedCargoCaseMan[0]?.status)} alt={'иконка'}/>
                </div>
                <div className="selected-doc-set-bol-title__select-template">
                    {/*<UploadTemplateDocument*/}
                    {/*    isOptionsTemplate={isOptionsTemplate}*/}
                    {/*    isSelectTemplate={isSelectTemplate}*/}
                    {/*    setSelectTemplate={setSelectTemplate}*/}
                    {/*    isLinkTemplate={isLinkTemplate}*/}
                    {/*/>*/}
                <SendForSignature
                    selectedCargoCaseMan={selectedCargoCaseMan}
                    onEditHandler={onEditHandler}
                    cargoCaseDocId={cargoCaseDocId}
                    setTextMessage={setTextMessage}
                    isLinkTemplate={isLinkTemplate}
                />
                </div>
            </div>
            <div className="selected-doc-set-man-message">
                <p>{isTextMessage}</p>
            </div>
            <div className="selected-doc-set-man-doc-info">
                <div className="selected-doc-set-man-doc-info__selected-doc-image-page">
                    <img className="selected-doc-set-man-doc-info__selected-doc-image" src={imageDoc} alt={'изображение документа'}/>
                </div>
                {selectedCargoCaseMan.map((el) => {
                    return (
                        <div key={el.id} className="selected-doc-set-man-doc-info__text-fields">
                            <h4 className="selected-doc-set-man-doc-info__selected-doc-info-title">Doc info</h4>
                            <div className="selected-doc-set-man-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Bill of lading number</label>
                                    <p>{isBolsNumbers?.toString()}</p>
                                </div>
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Date of loading</label>
                                    <p>{el?.dateOfLoading}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-man-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Shipowner</label>
                                    <p>{el?.shipowner?.name}</p>
                                </div>
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Vessel</label>
                                    <p>{el?.vesselName}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-man-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Captain</label>
                                    <p>{el?.captain?.firstName} {el?.captain?.lastName}</p>
                                </div>
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Final Destination</label>
                                    <p>{el?.portOfDischargeName}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-man-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Port of loading</label>
                                    <p>{el?.portOfLoadingName}</p>
                                </div>
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Port of discharge</label>
                                    <p>{el?.portOfDischargeName}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-man-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Description of Goods</label>
                                    <p>{el?.kindOfGood}</p>
                                </div>
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Freight</label>
                                    <p>{el?.freight}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-man-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Shipper’s Agent</label>
                                    <p>{el?.shippersAgent}</p>
                                </div>
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Consignee</label>
                                    <p>{el?.consignee}</p>
                                </div>
                            </div>
                            <div className="selected-doc-set-man-doc-info__selected-doc-info-group-input">
                                <div className="selected-doc-set-man-doc-info__selected-doc-info-input">
                                    <label>Shipper</label>
                                    <p>{el?.shipperName}</p>
                                </div>
                            </div>
                        </div>
                    )})}
            </div>
            <div className={getCurrentListManCorrector?.length !== 0 ? "selected-doc-set-man-corrector-table" : "selected-doc-set-man-corrector-table hide"}>
                <div className="selected-doc-set-man__change-log">
                    <h4 className="selected-doc-set-man__change-log-title">MAN corrector</h4>
                </div>
                <div className="selected-doc-set-man-corrector-table-header">
                    <p>Number</p>
                    <p>Type</p>
                    <p>Date</p>
                    <p>Status</p>
                </div>
                {getCurrentListManCorrector.map((el, i) => {
                    return (
                        <div onClick={() => onShowSelectManCorrector(el.id)} key={i} className="selected-doc-set-man-corrector-table-row">
                            <p>{el?.number}</p>
                            <p>{el?.correctionType}</p>
                            <p>{el?.dateOfCorrection}</p>
                            <div className="selected-doc-set-man__change-log-table-row-img-status">
                                <img className="selected-doc-set-man__change-log-img" src={findStatusDocument(el?.status)} alt={'иконка статуса'}/>
                            </div>
                        </div>
                    )})}
                {activeModalManCorrector && (
                    <CreateDocSetManCorrectorModal
                        onClose={() => {setActiveModalManCorrector(false)
                                                   setSelectedManCorrector({})}}
                        selectedCargoCaseMan={selectedCargoCaseMan}
                        cargoCaseDocId={cargoCaseDocId}
                        isSelectedManCorrector={isSelectedManCorrector}
                    />
                )}
            </div>
            <div className="selected-doc-set-man__change-log">
                <h4 className="selected-doc-set-man__change-log-title">Change log</h4>
            </div>
            <div className="selected-doc-set-man__change-log-table-header">
                <p>Action</p>
                <p>Doer</p>
                <p>Status</p>
                <p>Date</p>
            </div>
            {currentStatusMan.map((el) => {
                return (
                    <div key={el?.id} className="selected-doc-set-man__change-log-table-row">
                        <p>{el?.description}</p>
                        <p>{el?.user}</p>
                        <div className="selected-doc-set-man__change-log-table-row-img-status">
                            <img className="selected-doc-set-man__change-log-img" src={findStatusDocument(el?.status)} alt={'иконка статуса'}/>
                        </div>
                        <p>{el?.date}</p>
                    </div>
                )})}
        </div>
    )
}
export default SelectedDocSetMan;